export enum TextDirection {
  RTL = 'rtl',
  LTR = 'ltr',
}
